import type { Provider, ProviderIos } from "./ports";

class Service {
  private readonly provider: Provider;

  constructor(provider: Provider) {
    this.provider = provider;
  }

  create(params: ProviderIos.Create.In) {
    return this.provider.create(params);
  }

  update(params: ProviderIos.Update.In) {
    return this.provider.update(params);
  }

  delete(params: ProviderIos.Delete.In) {
    return this.provider.delete(params);
  }

  resolve(params: ProviderIos.Resolve.In) {
    return this.provider.resolve(params);
  }

  get(params: ProviderIos.Get.In) {
    return this.provider.get(params);
  }

  getMany() {
    return this.provider.getMany();
  }

  getPaginated(params: ProviderIos.GetPaginated.In) {
    return this.provider.getPaginated(params);
  }
}

export { Service };
